var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.passage.absolute,staticClass:"word-list-widget"},[(_vm.filteredWordList.length > 0)?_c('WordList',{attrs:{"wordList":_vm.filteredWordList}}):_c('EmptyMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }